// extracted by mini-css-extract-plugin
export default {"imageContainer":"image_imageContainer__THT-p","overlay":"image_overlay__JCRQ2","image":"image_image__W9Jg9","bigImage":"image_bigImage__3i4D8"};